import { useParams } from "react-router-dom"
import { Uuid } from "types"

export const usePageId = () => {
    const { id } = useParams() as { id?: Uuid }

    return { id }
}
